import { Component,  ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { ResourceRS, ResourcesRS } from 'src/app/core/models/resources/resources-response';
import { ResourcesService } from 'src/app/core/services/api/resources.service';


const URL = 'https://myswagger/api/';
@Component({
  selector: 'app-file-drop-zone',
  templateUrl: './file-drop-zone.component.html',
  styleUrls: ['./file-drop-zone.component.scss']
})
export class FileDropZoneComponent  implements OnInit {
  @Input() siteId: string;
  @Input() resourcesList?: ResourcesRS[] = [];

  selectedFiles?: FileList;
  previews :  string[] = [];


  resourceResponse: ResourcesRS = {};
  deletedResources:string[] =[];
  loading: boolean = false;
  //productResources:ResourcesRS[] = [];
  uploader: FileUploader = new FileUploader({
    url: URL,
    isHTML5: true
  });
  hasBaseDropZoneOver = false;
  hasAnotherDropZoneOver = false;


  constructor(private resourceService: ResourcesService) { }

  ngOnInit() {}
  
  selectFiles(event: any): void {
    //this.message = [];
    //this.progressInfos = [];
    this.selectedFiles = event;
  
    this.previews = [];
    if (this.selectedFiles && this.selectedFiles[0]) {
      const numberOfFiles = this.selectedFiles.length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();
  
        reader.onload = (e: any) => {
          console.log(e.target.result);
          this.previews.push(e.target.result);
        };
  
        reader.readAsDataURL(this.selectedFiles[i]);
      }
    }
  }
  //TODO show pictures and check for url in the object if not upload. if upload faild the delete object 
  
  dropped(files): void{

    console.log("onfile drop");
    console.log(files);
    //console.log(this.uploader);
    this.selectedFiles = files;
    //this.previews = [];
    for (let index = 0; index < files.length; index++) {
      this.loading = true;
      let fileSubType = files[index].type.split("/");
      switch (fileSubType[0]) {
        case "image": {
          
          let reader = new FileReader();
          
          reader.onload = (e:any) => {
          this.resourceResponse.fileReader = e.target.result;
          this.previews.push(e.target.result);
          };
          reader.readAsDataURL(files[index]);
          this.uploadResource(ResourceRS.TypeEnum.PHOTO, files[index]);
          break;
        }
        case "audio": {
          this.uploadResource(ResourceRS.TypeEnum.AUDIO, files[index]);
          break;
        }
        case "application": {
          if (fileSubType[1] == "pdf") {
            this.uploadResource(ResourceRS.TypeEnum.PDF, files[index]);
          }
          
          break;
        }
      }
    }
    this.loading = false;
    console.log('after drop');
    console.log(this.resourcesList);

    console.log("previews files");
    console.log(this.previews);
    
    
  }
  // Angular2 File Upload
  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
   
  }

  fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
   
  }

  uploadResource(fileType: string, fileToUpload?: File, url?: string) {
    console.log("product to edit BEFORE  upload new file ");
    this.setResourcesData(fileToUpload, fileType);
    this.resourceResponse = {};
    let fileData: FormData = new FormData();
    fileData.set("siteId", this.siteId);
    fileData.set("type", fileType);
    fileData.append("target", 'ITEM');
    fileData.append("url", url);
    fileData.append("file", fileToUpload);
    this.resourceResponse.type = ResourceRS.TypeEnum.PHOTO;
    
    //this.setResourcesData(fileToUpload, fileType);
    /*this.resourceService.uploadResource(fileData).subscribe(
      (res) => {
        this.resourceResponse = JSON.parse(JSON.stringify(res));
        this.setResourcesData(fileToUpload, fileType);
        console.log(
          "product to edit after  upload new file  and set resource data"
        );
        
      },
      (error) => {
        console.log("error uploading resources " + error);
      }
    );*/
  }

  setResourcesData(file: File, fileType: string) {
    console.log('setting resource data');
    console.log(fileType);
    switch (fileType) {
      case ResourceRS.TypeEnum.PHOTO: {
        let reader = new FileReader();
        
        reader.onload = (e:any) => {
        this.resourceResponse.fileReader = e.target.result;
        };
        reader.readAsDataURL(file);

       
        
        break;
      }
      case ResourceRS.TypeEnum.VIDEO: {
        this.resourceResponse.type = ResourceRS.TypeEnum.VIDEO;
        break;
      }
      case ResourceRS.TypeEnum.AUDIO:
      case ResourceRS.TypeEnum.PDF: {
        this.resourceResponse.file = file;
        break;
      }
    }
    
    this.resourcesList.push(this.resourceResponse);
  }

  //------------------------Remove product resources----------------//
  removeResource(resource: ResourcesRS) {
    let indexArry: number = this.resourcesList.indexOf(resource);
    if (indexArry != -1) {
      this.deletedResources.push(resource.id);
      this.resourcesList.splice(indexArry, 1);
      if (!this.resourcesList) {
        this.resourcesList = [];
      }
    }
    console.log("delete from product resources to send to server");
    console.log(this.resourcesList);
  }

  openFile(url: string) {
    window.open(url);
  }
}
